import { post } from 'core_main/request';
import { CHAT_IDENTITY_ENDPOINT } from './constants';
import { maybeFetchCurrentTrackingToken } from '../tracking';
import { CreateIdentityParameters } from './types';
import { validateCreateIdentityParams } from './helpers';

export const createIdentity = (parameters: CreateIdentityParameters) => {
  const validateMessageParamsError = validateCreateIdentityParams(parameters);

  if (validateMessageParamsError) {
    return Promise.reject(validateMessageParamsError);
  }

  return maybeFetchCurrentTrackingToken().then(() => {
    return post(CHAT_IDENTITY_ENDPOINT, {
      body: JSON.stringify(parameters),
    }).then((response) => {
      return response;
    });
  });
};
